import React, { useRef, useState, useEffect } from "react";
import { Box, Tab, Tabs, Typography, Paper } from "@mui/material";
import Delivery_report from "./Delivery_report";
import Return_report from "./Return_report";
import styles from "../../../styles.module.css";
import { Breadcrumb, CTSinput, SearchInput, StyledTableCell, StyledTableRow } from "../../reusableComponent/Reusables";
import HeaderSection from "../../reusableComponent/HeaderSection"; // Adjusted import path

const Daily_Distribution_Report = () => {
    const [tabIndex, setTabIndex] = useState(0);

    const handleChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    return (
        <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
            <Box className={styles.body}>
                <Breadcrumb routeSegments={[{ name: "Daily Distribution Report" }]} />

                {/* <HeaderSection
                    title="Daily Distribution Report"
                    searchKey={searchKey}
                    handleSearch={handleSearch}
                    sortedRows={sortedRows}
                    fields={fields}
                    labels={labels}
                    filename="Daily Distribution Report"
                    paginationInfo={paginationInfo}
                    controller={controller}
                    handleChangePage={handleChangePage}
                /> */}



                <Tabs
                    value={tabIndex}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="standard"
                    scrollButtons="auto"
                    style={{ borderBottom:'1px solid #e7e7e7' }}
                >
                    <Tab label="Delivery" sx={{textTransform:'none'}} />
                    <Tab label="Return" sx={{ textTransform: 'none' }} />
                </Tabs>

                <Box sx={{ p: 2 }}>
                    {tabIndex === 0 && <Delivery_report />}
                    {tabIndex === 1 && <Return_report />}
                </Box>
            </Box>
        </Box>
    );
};

export default Daily_Distribution_Report;
